
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as bloguNGut8OsK3QrFWTu_cCHIcQ_457Zak81_avDcBTVOgbEEMeta } from "/opt/buildhome/repo/pages/blog.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as signinaylz3r6O1tieA6x84_07JdujxSHcbCHwbEcHPnAwrQgMeta } from "/opt/buildhome/repo/pages/signin.vue?macro=true";
import { default as _91_46_46_46slug_93kxjr4BRGYu8PjICw6eKIYYGNlIv1T0FK9GFhjf_45hT6QMeta } from "/opt/buildhome/repo/pages/[...slug].vue?macro=true";
import { default as indexv37UAAEeM5fxWwo8N4j4Nil_RtdTUwSP54YHqm6Px3sMeta } from "/opt/buildhome/repo/pages/app/index.vue?macro=true";
import { default as indexCdyEsIHVVQ2YioKNndLx99kfNH4urUSgUOEc29CPNr0Meta } from "/opt/buildhome/repo/pages/app/user/index.vue?macro=true";
import { default as setup43UsLgU9h_45bI_s0kLgfi4cLSKQ_45n5cOSB1vmv8AWFl0Meta } from "/opt/buildhome/repo/pages/app/user/setup.vue?macro=true";
import { default as _91id_93gsutk8m0LvJE2pSirXAT_45n3vC7Yk7CZ8KyfuPIj5fIQMeta } from "/opt/buildhome/repo/pages/app/reports/[id].vue?macro=true";
import { default as settingsntJCOfacdTKBFJga3O2Yu4xelztcXWnsYAOWFUcVbI8Meta } from "/opt/buildhome/repo/pages/app/user/settings.vue?macro=true";
import { default as _91id_93SscQOnLCTl_45dEQqnS2nEIqBpsnJe0Q_45I6QHqXORUs9UMeta } from "/opt/buildhome/repo/pages/app/transaction/[id].vue?macro=true";
import { default as postcheckoutvU40zXDXi4Ak9Lg__45lEnFWusk_quX_45vIZXvtIfstuPAMeta } from "/opt/buildhome/repo/pages/app/user/postcheckout.vue?macro=true";
export default [
  {
    name: "blog",
    path: "/blog",
    component: () => import("/opt/buildhome/repo/pages/blog.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/opt/buildhome/repo/pages/signin.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...slug].vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/opt/buildhome/repo/pages/app/index.vue")
  },
  {
    name: "app-user",
    path: "/app/user",
    meta: indexCdyEsIHVVQ2YioKNndLx99kfNH4urUSgUOEc29CPNr0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/app/user/index.vue")
  },
  {
    name: "app-user-setup",
    path: "/app/user/setup",
    meta: setup43UsLgU9h_45bI_s0kLgfi4cLSKQ_45n5cOSB1vmv8AWFl0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/app/user/setup.vue")
  },
  {
    name: "app-reports-id",
    path: "/app/reports/:id()",
    meta: _91id_93gsutk8m0LvJE2pSirXAT_45n3vC7Yk7CZ8KyfuPIj5fIQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/reports/[id].vue")
  },
  {
    name: "app-user-settings",
    path: "/app/user/settings",
    meta: settingsntJCOfacdTKBFJga3O2Yu4xelztcXWnsYAOWFUcVbI8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/app/user/settings.vue")
  },
  {
    name: "app-transaction-id",
    path: "/app/transaction/:id()",
    meta: _91id_93SscQOnLCTl_45dEQqnS2nEIqBpsnJe0Q_45I6QHqXORUs9UMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/transaction/[id].vue")
  },
  {
    name: "app-user-postcheckout",
    path: "/app/user/postcheckout",
    meta: postcheckoutvU40zXDXi4Ak9Lg__45lEnFWusk_quX_45vIZXvtIfstuPAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/app/user/postcheckout.vue")
  }
]